export default __webpack_public_path__ + "static/media/WinfieldsChocolateBar_logo.5d372608.svg";